(() => {
  const dialog = document.getElementById('HeroPaymentMethods');
  if (!dialog) return;
  let opener;

  document.addEventListener('click', (event) => {
    const trigger = event.target.closest('[data-hero-payment-trigger]');
    if (!trigger) return;
    event.preventDefault();
    opener = trigger;
    dialog.querySelector('[data-payment-estimate-detail]').textContent =
      `From ${trigger.dataset.monthlyPrice}/month`;
    dialog.querySelector('.element-cart-payments__finance small').textContent =
      `Example based on ${trigger.dataset.financeMonths} months. Payment plans vary by provider.*`;
    openCartDialog(dialog);
    dialog.focus({ preventScroll: true });
  });

  dialog.addEventListener('click', (event) => {
    if (event.target.closest('[data-dismiss-cart-info]') || event.target === dialog) {
      closeCartDialog(dialog);
    }
  });

  dialog.addEventListener('cancel', (event) => {
    event.preventDefault();
    closeCartDialog(dialog);
  });

  dialog.addEventListener('close', () => opener?.focus({ preventScroll: true }));
})();
